const MOBILE_BREAKPOINT = 768

export function isMobile() {
  return window.innerWidth <= MOBILE_BREAKPOINT
}

export function isMobileUA() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function checkMobile() {
  return isMobile() || isMobileUA()
}
